import axios from 'axios';

export default {
  async loginWithADCredentials(credentials) {
    console.log(credentials);
    return Promise.resolve(false);
  },

  async getShopsByMgmt(email) {
    const list = await axios.post(process.env.VUE_APP_LIST_SHOPS_BY_MGMT_ENDPOINT, {
      headers: {
        'Content-type': 'application/json',
      },
      params: {
        email,
      },
    });
    console.log(list.data.data.sectors);
    return list.data.data.sectors;
  },
};
